import { type FC } from 'react';
import { Input } from '@shared/components/ui/input';
import type { FieldErrors, UseFormRegister, RegisterOptions } from 'react-hook-form';

interface FormFieldProps {
  id: string;
  label: string;
  type?: string;
  placeholder?: string;
  register: UseFormRegister<any>;
  validation: RegisterOptions;
  errors: FieldErrors;
  allowedCharsPattern?: RegExp;
}

/**
 * Переиспользуемое поле формы с валидацией и отображением ошибок
 */
export const FormField: FC<FormFieldProps> = ({
  id,
  label,
  type = 'text',
  placeholder,
  register,
  validation,
  errors,
  allowedCharsPattern,
}) => {
  const error = errors[id];
  const { onChange, ...registerRest } = register(id, validation);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (allowedCharsPattern) {
      const filteredValue = e.target.value
        .split('')
        .filter(char => allowedCharsPattern.test(char))
        .join('');
      e.target.value = filteredValue;
    }
    onChange(e);
  };

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium mb-1">
        {label}
      </label>
      <Input
        id={id}
        type={type}
        placeholder={placeholder}
        {...registerRest}
        onChange={handleChange}
        className={error ? 'border-status-error' : ''}
      />
      {error && <p className="mt-1 text-xs text-status-error">{String(error.message)}</p>}
    </div>
  );
};
